export default "<div class=\"wrapper\" [@fadeInOut]>\r\n  <router-outlet></router-outlet>\r\n</div>\r\n\r\n"